// Module
var code = "<template class=\"mooring-components-tab\">\n  <require from=\"./review\"></require>\n  <review mooring-id.bind=\"data.mooringId\" offer-id.bind=\"data.offerId\" review-id.bind=\"data.activeReviewId\"></review>\n</template>\n";
// Exports
export default code;